// A single shared stage: product photos never replace or recreate the 3D renderer.
const galleries = new Map();
function initialiseGallery(root) {
  if (galleries.has(root)) return;
  const gallery = root.querySelector('[data-name-gallery]');
  if (!gallery) return;
  const photo = root.querySelector('[data-gallery-photo]');
  const image = root.querySelector('[data-gallery-image]');
  const back = root.querySelector('[data-gallery-back]');
  const status = root.querySelector('[data-preview-status]');
  const buttons = [...gallery.querySelectorAll('.onn-gallery__thumb')];
  const live = gallery.querySelector('[data-gallery-live]');
  function showLive() {
    photo.hidden = true;
    back.hidden = true;
    root.classList.remove('is-viewing-photo');
    status.hidden = false;
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button === live)));
  }
  function select(event) {
    const button = event.target.closest('button');
    if (!button || !gallery.contains(button)) return;
    if (button === live) return showLive();
    if (!button.dataset.gallerySrc) return;
    image.src = button.dataset.gallerySrc;
    image.alt = button.dataset.galleryAlt;
    photo.hidden = false;
    back.hidden = false;
    root.classList.add('is-viewing-photo');
    status.hidden = true;
    buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }
  // Product controls move into the native form without recreating the renderer.
  // Listen on the document so that moving them does not break the gallery.
  function personalise(event) {
    if (event.target.matches('[data-product-name], [data-name], input[name^="onn-product-"], input[name^="onn-font-"], input[name^="onn-chain-"], input[name^="onn-length-"], input[name^="onn-thickness-"]')) showLive();
  }
  function jumpToPreview(event) {
    const button = event.target.closest('[data-gallery-jump]');
    if (!button || button.getAttribute('aria-controls') !== root.id) return;
    showLive();
    root.querySelector('.onn__preview').scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
    const canvas = root.querySelector('[data-canvas]');
    canvas.tabIndex = -1;
    canvas.focus({ preventScroll: true });
  }
  const returnToLive = () => { showLive(); live.focus({preventScroll:true}); };
  back.addEventListener('click', returnToLive);
  document.addEventListener('click', jumpToPreview);
  gallery.addEventListener('click', select);
  document.addEventListener('input', personalise);
  document.addEventListener('change', personalise);
  galleries.set(root, () => {
    back.removeEventListener('click', returnToLive);
    document.removeEventListener('click', jumpToPreview);
    gallery.removeEventListener('click', select);
    document.removeEventListener('input', personalise);
    document.removeEventListener('change', personalise);
  });
}
function initialise() {
  for (const [root, cleanup] of galleries) {
    if (!root.isConnected) { cleanup(); galleries.delete(root); }
  }
  document.querySelectorAll('.onn--product').forEach(initialiseGallery);
}
initialise();
document.addEventListener('shopify:section:load', initialise);
document.addEventListener('shopify:section:unload', event => {
  for (const [root, cleanup] of galleries) {
    if (event.target.contains(root)) { cleanup(); galleries.delete(root); }
  }
});
